var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3786.76 786.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#e18e3c;}.cls-4{fill:#2e2e2e;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 -50.42)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 3786.78,
    height: 827.17
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-3",
    d: "M756.07,612.67a238.08,238.08,0,0,0,27-21.36,610.25,610.25,0,0,0,44.27-46.56l-.26-.26L709,572.42a324.53,324.53,0,0,0,47.08,40.18",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-3",
    d: "M824.87,655.41a143.36,143.36,0,0,0,55.74-17.36,109.41,109.41,0,0,0,28.17-25.93l-10.92-18.2a362.26,362.26,0,0,1-45.52-28.09,391.27,391.27,0,0,1-58.5,70.23,305,305,0,0,0,28.91,13.67Z",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-3",
    d: "M840.21,755.82a139.88,139.88,0,0,0,14.1,13.55,504,504,0,0,1,55.85-100.21,182.48,182.48,0,0,1-93.64,23.46l-11.14,22.8c11.88,13.15,22.68,27.11,34.78,40.35",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "cls-3",
    d: "M832.44,801.29A267.05,267.05,0,0,1,788.55,750L782,763.48,749.78,755a44.66,44.66,0,0,0-48.2,22.32c-7.2,13.14-15.46,29.05-22.07,44.14h154s2-5.68,5.58-15a69.16,69.16,0,0,1-6.57-5.11",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    className: "cls-3",
    d: "M502.94,628.27,452.85,739.89a43.47,43.47,0,0,1,30.08,31.87C478,790,466.72,824.33,450.36,832.18h41.36c41.27-67.6,29.46-154.52,11.22-203.89",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    className: "cls-3",
    d: "M418.59,711.56A298.77,298.77,0,0,1,390.66,679a271.34,271.34,0,0,1-26.53,111l-65.81-12.88a69.42,69.42,0,0,0-32.86,60.09H407l39.43-99.53c-10.33-8.88-19.71-18-27.93-26.09",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    className: "cls-3",
    d: "M1059.72,543.16C1002,521.31,975.4,496.32,977,422.92c0,0,3.12,37.48,50,65.58,20,12,43.27,21.69,64.71,33.24a341.29,341.29,0,0,1-.62-65.11,423.9,423.9,0,0,0-39.82-88.53c12.76-1.23,24.92-2.84,36.6-4.74q-10.12-27.19-19.85-54.51a12.41,12.41,0,0,1,0-8.82,815.82,815.82,0,0,1-97.41-24.35,259.17,259.17,0,0,0-35-23.43,189.41,189.41,0,0,1-39.67,41.07A185.19,185.19,0,0,0,824,376.09,164.42,164.42,0,0,1,864.64,284c20.93-22.67,33.09-29.77,41.07-44.93A237.64,237.64,0,0,0,782,231.31c-2.17.39-4.4.74-6.57,1.1-22,13.9-52.35,44-59.14,106.2C705.26,438.48,663.1,494.7,560,510.3c0,0,82.77-29.67,110.87-110.87,22.18-64.07,8.45-110.63,46.84-161.14-23.39,1.25-47.21,1.28-70.13.46a138.43,138.43,0,0,0-15.76,73.32c3.47,71-39.72,123-104.86,130.21a122.25,122.25,0,0,0,71.81-85c6.8-37.26,2.42-82.59,7.08-121-10.68-.9-20.89-2-30.52-3.14-4.4,83.55-45,116.36-45,116.36a230.43,230.43,0,0,0,13.38-121.07A99,99,0,0,1,498.64,214a36.71,36.71,0,0,0-6.57-7.5A98.71,98.71,0,0,0,468.86,263c-7.81,76.52-96.81,107.75-96.81,107.75a212.06,212.06,0,0,0,65.66-92.11c8.61-29.26,10.59-59,22.62-83.41H397a99.9,99.9,0,0,0-15.51,93.3c9.36,37.49-27.08,61.42-27.08,61.42s16.66-15.62-5.2-73.92a99.86,99.86,0,0,1,1.36-75.29c-8.46,1.87-17.74,4-27.2,6.19-26.55,34.14-14.33,72,7.09,114.9a80.69,80.69,0,0,1-8.33,89.53,200.93,200.93,0,0,0-32.28-119.71,97.45,97.45,0,0,1-17.16-72.56c-16.12,3.92-27.32,6.73-27.32,6.73l-21.46,19.32a49.73,49.73,0,0,0,4.29-50.43c-38.64,26.82-170.64,78.34-170.64,78.34l-5.36,25.4A148.23,148.23,0,0,1,0,322.09,94.71,94.71,0,0,0,47.94,368.6l7.92-20.77c39.42-3.58,41.49,46.51,41.49,46.51l-32.2-7.87a113.63,113.63,0,0,1,24.32,54.38l55.1-42.93,50.79,2.86c47.92-40.78,7.87-98,7.87-98,47.22,43.65,15,100.87,15,100.87a176.51,176.51,0,0,1,41.3,22.14,71.93,71.93,0,0,0,6.31-52.88c-11.5-54.13-32.26-76-12.5-112.43a112.12,112.12,0,0,0,23.95,85.42,114.46,114.46,0,0,1,19.14,111.4,287.76,287.76,0,0,1,24.64,27.93l27.19-64.38-21.37,84.39L345.09,539a233.3,233.3,0,0,0,35.33-97.39c7.81-68.72,101.5-62.42,129.6-156.15,0,0,1.65,73.39-42.15,99.95a113.67,113.67,0,0,0-57.78,114c3.91,27.33-15.36,70.46-30.37,99,20.45,24.06,36.6,53.72,58.61,75.91Q450,686.07,462.68,696.7l31.62-79.84-17.16-81.55c12.88-4.29,38.62-47.23,38.62-47.23A259.38,259.38,0,0,1,490,536.74l14.3,68.68L546,596A106.3,106.3,0,0,1,601.1,549.9c41.65-14.58,77-72.88,77-72.88s-11.5,60.37-44.75,75A76.37,76.37,0,0,0,601,583.54L634.35,576a186.37,186.37,0,0,0,90.54-121c21.81-114.77,46.78-152.78,90.17-182.35,0,0-56.76,89.93-49.1,171.49,3.71,39.54-15.74,79.6-36.77,110.41l91.34-20.66a445.78,445.78,0,0,1,8.59-101.59s4.31,85.85,7.17,90.14a149,149,0,0,0,44.84,43.65,200.75,200.75,0,0,1-13.52-93.23c10.42-79.12,68.72-95.78,77-149.91a139.7,139.7,0,0,1-8.26,77c-14.39,28.76-64.35,82.4,9.31,190.28a145.22,145.22,0,0,0,23.72,2.27l27.77,19.84c5.73-1.64,11.22-3.28,16.21-5.1a240,240,0,0,0,79.05-46.45,133.08,133.08,0,0,0-32.74-17.64",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    className: "cls-3",
    d: "M1105.43,703.27c4.43.84,9.47,1.64,15.55,2.48a222.1,222.1,0,0,0,70.28-.31,145.37,145.37,0,0,0,5.65-30c-2.86-4.29-41.49-1.43-78.69-64.38-2.48-4.21-4.7-8.6-6.78-13a231.06,231.06,0,0,1-65.62,44c-1.46.67-3,1.25-4.43,1.91l62.1,44.35Z",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    className: "cls-3",
    d: "M1160.13,754.19a204.09,204.09,0,0,1-48.41-3.28l3.63,27.52a212.4,212.4,0,0,0-51.52-8.58c-55.67,18.56-54.38,57.24-54.38,57.24H1159.7s10.09-37.12,19.72-74.62c-6.44.75-12.88,1.35-19.34,1.64",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-3",
    d: "M1139.84,301.42a196.66,196.66,0,0,1-46.31,1.64q11,27.48,22.2,54.82,18-4,34-9.28a406.51,406.51,0,0,0-9.86-47.2",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-3",
    d: "M1234.44,58.53a91,91,0,0,0-72.62-1.08,84.76,84.76,0,0,0-20,12.94,15.57,15.57,0,0,0,16.43,26,79.5,79.5,0,0,1,48.59-3.5,141.21,141.21,0,0,1,27.59-34.35",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-3",
    d: "M1237.77,107.93a72,72,0,0,1,27,52,154.66,154.66,0,0,1,32.3,5.61v-.92a113.73,113.73,0,0,0-29.74-83.43,126.75,126.75,0,0,0-29.57,26.69",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    className: "cls-3",
    d: "M1258.75,198.75A154.48,154.48,0,0,1,1239,235.92a274.73,274.73,0,0,1,18.78,43.62,172.13,172.13,0,0,0,34-71.25,130,130,0,0,0-33-9.54",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    className: "cls-3",
    d: "M1226.71,306.15a320.27,320.27,0,0,0-11.35-42.6A140.65,140.65,0,0,1,1171,292.63a355.36,355.36,0,0,1,12.83,42.62,229,229,0,0,0,43.33-26.11c-.18-1-.34-2-.52-3",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    className: "cls-4",
    x: 1564.67,
    y: 110.02,
    width: 118.38,
    height: 424.96
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    className: "cls-4",
    d: "M1760.76,160.44h109.88l174.83,224.63V160.44H2162v425h-103.2L1877.31,352.22V585.33H1760.67Z",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    className: "cls-4",
    d: "M2237.23,160.44h163.91c151.78,0,239.85,87.43,239.85,210v1.22c0,122.62-89.26,213.7-242.24,213.7H2237.23ZM2403,481c70.42,0,117.16-38.85,117.16-107.46v-1.21c0-68-46.75-107.46-117.16-107.46h-48V481Z",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    className: "cls-4",
    x: 2704.07,
    y: 110.02,
    width: 118.38,
    height: 424.96
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    className: "cls-4",
    d: "M3047.05,157.4h113.54l180.9,428H3215.23l-30.95-75.88H3020.36L2990,585.38H2866.15Zm103.21,260.43L3102.91,297,3055,417.81Z",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    className: "cls-4",
    d: "M3382.74,160.44h110l174.76,224.63V160.44H3784v425H3680.81L3499.27,352.22V585.33H3382.63Z",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    className: "cls-4",
    d: "M1642.19,779.36h-.93l-59.73-87.66V824.36h-18.07V660.31h18.74L1642,749.84l59.77-89.53h18.74V824.36H1702V691.47Z",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    className: "cls-4",
    d: "M1885.46,677.18H1785.38v56h89.53V750h-89.53v57.5h101.25v16.87H1766.85v-164h118.61Z",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    className: "cls-4",
    d: "M2061.68,774.55a76.23,76.23,0,0,1-17.92,26.14A84.8,84.8,0,0,1,2016.11,818a95.3,95.3,0,0,1-35.27,6.32h-57V660.29h57a97.18,97.18,0,0,1,35.27,6.21,83.44,83.44,0,0,1,27.65,17.23,76.5,76.5,0,0,1,17.94,26A82.32,82.32,0,0,1,2068,742.1a83.32,83.32,0,0,1-6.33,32.47M2044,717.07a61.11,61.11,0,0,0-13.59-20.73A62.66,62.66,0,0,0,2009,682.5a75.34,75.34,0,0,0-28.13-5H1942.4V807.24h38.44a77,77,0,0,0,28.13-4.93,61.2,61.2,0,0,0,21.45-13.72,61.82,61.82,0,0,0,13.59-20.5,66.65,66.65,0,0,0,4.81-25.54A67.93,67.93,0,0,0,2044,717",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    className: "cls-4",
    x: 2108.8,
    y: 609.89,
    width: 18.51,
    height: 164.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    className: "cls-4",
    d: "M2328.15,824.36H2308.3L2289.08,781h-89.37l-19.45,43.36h-19L2236,659.14h17.35Zm-83.67-143.43L2207,764.59h74.76Z",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    className: "cls-4",
    d: "M2447,711.69a21,21,0,0,0,6.8,8.56,49.51,49.51,0,0,0,13.59,7,163.17,163.17,0,0,0,22.26,6,96.72,96.72,0,0,1,40.43,16.91,36.62,36.62,0,0,1,13,29.8,43.3,43.3,0,0,1-15.66,34,51.29,51.29,0,0,1-17.62,9.4,74,74,0,0,1-22.51,3.29,98.22,98.22,0,0,1-36-6.36,101.84,101.84,0,0,1-31.05-19.71l11.5-13.61a96.85,96.85,0,0,0,26,17.47,75,75,0,0,0,30.23,5.73,42.16,42.16,0,0,0,26.6-7.74,24.63,24.63,0,0,0,9.95-20.43,27.19,27.19,0,0,0-1.87-10.44,21,21,0,0,0-6.57-8.33,46.9,46.9,0,0,0-13-6.81,168.1,168.1,0,0,0-21.26-5.87,168.54,168.54,0,0,1-24.54-7.05,60.52,60.52,0,0,1-17.27-9.62,35.46,35.46,0,0,1-10.1-13.14A44.21,44.21,0,0,1,2426.6,703a40.94,40.94,0,0,1,4-18.07,41.79,41.79,0,0,1,11.26-14.19,54.66,54.66,0,0,1,17.1-9.4,65.75,65.75,0,0,1,21.55-3.4,91.35,91.35,0,0,1,31.53,4.93,96,96,0,0,1,26.13,14.95l-10.77,14.29a80.08,80.08,0,0,0-23.09-13.58,70.38,70.38,0,0,0-24.26-4.21,46.61,46.61,0,0,0-14.41,2.1,36.76,36.76,0,0,0-11,5.64,24.38,24.38,0,0,0-7,8.46,23.4,23.4,0,0,0-2.47,10.55,28.26,28.26,0,0,0,1.88,10.56",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    className: "cls-4",
    d: "M2643.6,824.36h-18.52V759.45l-68.19-99.13h22.49l55.18,82,55.66-82h21.55l-68.19,98.9Z",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    className: "cls-4",
    d: "M2862.26,660.31h18.07V824.36h-14.79L2759.61,689.85V824.36h-18.07V660.31h17.35l103.35,131.42Z",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    className: "cls-4",
    d: "M3064.48,774.55a76.3,76.3,0,0,1-17.93,26.14A85,85,0,0,1,3018.9,818a95.3,95.3,0,0,1-35.27,6.32h-57V660.29h57a97.18,97.18,0,0,1,35.27,6.21,83.62,83.62,0,0,1,27.65,17.22,76.48,76.48,0,0,1,17.93,26,82.37,82.37,0,0,1,6.33,32.35,83.3,83.3,0,0,1-6.33,32.46m-17.69-57.5a61.33,61.33,0,0,0-13.58-20.73,62.82,62.82,0,0,0-21.46-13.83,75.3,75.3,0,0,0-28.12-5H2945.2V807.22h38.43a76.92,76.92,0,0,0,28.12-4.92,60.48,60.48,0,0,0,35-34.22,66.55,66.55,0,0,0,4.81-25.55,67.68,67.68,0,0,0-4.81-25.54",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    className: "cls-4",
    x: 3111.6,
    y: 609.89,
    width: 18.51,
    height: 164.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    className: "cls-4",
    d: "M3305.53,810.18a81.4,81.4,0,0,1-14.88,9,84.87,84.87,0,0,1-17.1,5.86,90.82,90.82,0,0,1-20.39,2.11,80.71,80.71,0,0,1-58.83-24.5,82,82,0,0,1-17.23-26.84,91.74,91.74,0,0,1,0-66.32,84.82,84.82,0,0,1,17.23-27.07,79.87,79.87,0,0,1,26.29-18.29,82,82,0,0,1,33.28-6.68,99.91,99.91,0,0,1,20.27,1.87,84.73,84.73,0,0,1,16.76,5.27,75.14,75.14,0,0,1,14.29,8.22,124.91,124.91,0,0,1,12.65,10.66l-12.65,13.58a103.39,103.39,0,0,0-22.62-16.16,63.3,63.3,0,0,0-74.29,13.14A66.16,66.16,0,0,0,3195,715.49a72.4,72.4,0,0,0-4.8,26.6,73.22,73.22,0,0,0,4.8,26.71,66.06,66.06,0,0,0,13.35,21.57,63.12,63.12,0,0,0,20.16,14.41,60.18,60.18,0,0,0,25.18,5.27,63.41,63.41,0,0,0,29.06-6.21,101.36,101.36,0,0,0,23.91-17.46l12.19,11.94a117.88,117.88,0,0,1-13.24,11.83",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    className: "cls-4",
    d: "M3503.9,824.36H3484L3464.75,781h-89.28L3356,824.36h-19l74.77-165.22h17.34Zm-83.67-143.43-37.47,83.66h74.76Z",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    className: "cls-4",
    d: "M3577,824.36h-18.51v-147h-55.07v-17.1h128.67v17.1H3577Z",
    transform: "translate(0 -50.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    className: "cls-4",
    d: "M3785.59,677.18H3685.51v56h89.54V750h-89.54v57.5h101.25v16.87H3667v-164h118.58Z",
    transform: "translate(0 -50.42)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImsLogo);
export default __webpack_public_path__ + "static/media/ims_logo.472d625ccab10b9b2580577af496d883.svg";
export { ForwardRef as ReactComponent };